export default {
  storefront_not_found: {
    title: 'Nenhuma loja encontrada',
    description: 'Por favor, crie uma loja.',
  },
};
